import { render, staticRenderFns } from "./song-contribution-index.vue?vue&type=template&id=4284ae4b&"
import script from "./song-contribution-index.vue?vue&type=script&lang=js&"
export * from "./song-contribution-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports